import GetFeedbackByOrganisationIdRequestModelBase from '../_generated/modelBases/get-feedback-by-organisation-id-request-model-base';

export default class GetFeedbackByOrganisationIdRequestModel extends GetFeedbackByOrganisationIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
